import captureException from '../../utils/captureException';
import { FETCH_ACCOUNTS_FULFILLED, FETCH_ACCOUNTS_PENDING, FETCH_ACCOUNTS_REJECTED } from './reducer';
export const fetchAccounts = ({
  dispatch,
  apiWrapper
}) => {
  dispatch({
    type: FETCH_ACCOUNTS_PENDING
  });
  apiWrapper.fetchAccounts().then(accounts => {
    dispatch({
      type: FETCH_ACCOUNTS_FULFILLED,
      payload: accounts
    });
  }).catch(err => {
    dispatch({
      type: FETCH_ACCOUNTS_REJECTED
    });
    captureException(err);
  });
};